function updateQty(id, quantity){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({quantity: quantity, id: id})
    });
}

function addProduct(variant_id){
    const cartLink = document.querySelector('#cart-icon-bubble');
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          {quantity: 1, id: variant_id}
        )
      }).then((response) => {
        if (response.ok) {
            cartLink.click()
        } else {}
      }).catch((error) => {})      
}

function addPack(variant_id1, variant_id2){
    addProduct(variant_id1);
    addProduct(variant_id2)
}


